/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deals_Mark_WonInputs */

const cs_deals_mark_won = /** @type {(inputs: Deals_Mark_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Označit jako vyhraný`)
};

const en_deals_mark_won = /** @type {(inputs: Deals_Mark_WonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as won`)
};

/**
* | output |
* | --- |
* | "Mark as won" |
*
* @param {Deals_Mark_WonInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deals_mark_won = /** @type {((inputs?: Deals_Mark_WonInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deals_Mark_WonInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deals_mark_won(inputs)
	return cs_deals_mark_won(inputs)
});